var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorFrecciaUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.23,757.55c34.45,42.37,96.77,48.71,139.13,14.26l237.46-193.45,239.77,195.35c42.37,34.45,104.68,28.11,139.13-14.26,34.54-42.37,28.19-104.6-14.18-139.13l-302.25-246.2c-18.22-14.84-40.31-22.25-62.48-22.25s-44.26,7.42-62.48,22.25L36.41,618.41c-42.28,34.54-48.71,96.77-14.18,139.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23,409.8c34.45,42.28,96.77,48.71,139.13,14.18l237.46-193.37,239.77,195.26c42.37,34.54,104.6,28.19,139.13-14.18,34.54-42.37,28.19-104.6-14.18-139.13L461.31,26.36c-18.22-14.84-40.31-22.25-62.48-22.25s-44.26,7.42-62.48,22.25L36.41,270.66c-42.28,34.45-48.71,96.77-14.18,139.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorFrecciaUp);
export default __webpack_public_path__ + "static/media/monitor-freccia-up.6b831173b439c53607f1beeb87500a2b.svg";
export { ForwardRef as ReactComponent };